jQuery(document).ready(($) => {
	$('#open-mobile-menu').on('click', () => {
		$('#mobile-navigation').fadeIn(300);
		$('body').addClass('disable-scroll');
	});

	$('#close-mobile-menu').on('click', () => {
		$('#mobile-navigation').fadeOut(300);
		$('body').removeClass('disable-scroll');
	});

	$('#mobile-menu li.menu-item-has-children > a').on('click', function (event) {
		event.preventDefault();

		const submenu = $(this).parent().children('ul.sub-menu');

		if ($(submenu).hasClass('open')) {
			$(submenu).removeClass('open');

			$(submenu).fadeOut(200);
		} else {
			$(submenu).addClass('open');
			$(submenu).fadeIn(200);
		}
	});

	$('#primary-menu li.menu-item-has-children > a').on('click', function (event) {
		event.preventDefault();

		const submenu = $(this).parent().children('ul.sub-menu');

		if ($(submenu).hasClass('open')) {
			$(submenu).removeClass('open');

			$(submenu).fadeOut(200);
		} else {
			$(submenu).addClass('open');

			$(submenu).fadeIn(200);
		}
	});

	// Breadcrumb check (katsoo näytetäänkö breadcrumb navigaation alla vai heron alla)
	if ($('.breadcrumb').length >= 2) {
		$('#nav-breadcrumb').remove();
	}

	// Hero with cards seuraavalle sectionille paddingia

	if($('.hero-block').hasClass('with-cards')) {
		$('section:nth-child(2)').addClass('padding-top');
	}

	// Ankkurointi
	$('a').on('click', function (event) {
		if (this.hash !== '') {
			event.preventDefault();

			const { hash } = this;
			const sectionTop = $(hash).offset().top - $('.site-header').height();

			$('html, body').animate(
				{
					scrollTop: sectionTop,
				},
				1000,
				() => {
					window.location.hash = hash;
				}
			);
		}
	});

	$('.sidebar-navigation li.page_item_has_children > a').after(
		'<button class="nav-button"><span class="material-icons-outlined nav-icon">add</span></button>'
	);

	$(document).on('click', '.page_item_has_children button.nav-button', function () {
		if ($(this).hasClass('open')) {
			$(this).removeClass('open');

			$(this).children('.nav-icon').text('add');

			$(this).parent().children('.children').fadeOut(200);
		} else {
			$(this).addClass('open');

			$(this).children('.nav-icon').text('remove');

			$(this).parent().children('.children').fadeIn(200);
		}
	});
});
